import * as emailSubscriptions from '@wix/auto_sdk_email-subscriptions_email-subscriptions';

export { emailSubscriptions };
